import { NavigationButton } from '../../generic/Button';
import Flex from '../../generic/Flex';
import { window } from '../../../globals';

/**
 * Header for the authentication pages.
 * Contains the logo.
 *
 */
const Header = () => (
  <header className="fossa-auth__header">
    <Flex justify="space-between" className="fossa-auth__header__content">
      {/*
        If the user is logged in but hasn't created/joined an org, they will be on the AuthOnboarding,
        and should be able to log out as an "escape hatch":
      */}
      { (window.user && !window.user.organization) && (
        <NavigationButton
          size="x-large"
          to={`${window.location.origin}/account/logout`}
        >
          Logout
        </NavigationButton>
      )}
    </Flex>
  </header>
);

export default Header;
